import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { ProfileSettings } from 'insify-remote-component-loader';
import { PageLoader } from '@instech/components';
import { useAccount } from '../../providers/authenticationProvider';
import Header from '../Header';
import style from './ProfileSettingsPage.module.scss';
import { FeatureEnum, useFeatureFlags } from '../../providers/FeatureFlagProvider';

const ProfileSettingsPage = () => {
  const account = useAccount();
  const history = useHistory();

  const featureFlags = useFeatureFlags();

  useEffect(() => {
    if (!!featureFlags.flagsLoaded && !featureFlags[FeatureEnum.PROFILESETTINGS]) {
      history.replace('/');
    }
  }, [featureFlags.flagsLoaded, featureFlags[FeatureEnum.PROFILESETTINGS], history]);

  if (!featureFlags.flagsLoaded) {
    return <PageLoader />;
  }

  if (!featureFlags[FeatureEnum.PROFILESETTINGS]) {
    return null; // Will redirect, so render nothing
  }

  return (
    <div className={style.wrap}>
      <div className={style.stickyHeader}>
        <Header />
      </div>
      <ProfileSettings account={account} history={history} />
    </div>
  );
};

export default ProfileSettingsPage;
